<template>
  <FormKit type="form" :actions="false" @submit="addNote">
    <FormKit
      type="textarea"
      name="note"
      label="Voeg een notitie toe aan de mail."
    />

    <div>
      <button type="submit" class="btn btn-primary">Notitie toevoegen</button>

      <button
        type="button"
        class="btn btn-secondary"
        @click="removeNote"
        v-if="!!modelValue"
      >
        Notitie verwijderen
      </button>
    </div>
  </FormKit>

  <div v-if="!!modelValue">
    <hr />

    <strong>Notitie:</strong>
    <p>{{ modelValue }}</p>
  </div>
</template>

<script>
export default {
  name: "NoteForm",
  props: {
    modelValue: {
      type: String,
    },
  },
  methods: {
    addNote({ note }) {
      this.$emit("update:modelValue", note);
    },
    removeNote() {
      this.$emit("update:modelValue", "");
    },
  },
};
</script>